module.exports = __webpack_public_path__ + "assets/jira.f8834abf.svg";